import React from 'react';
import CategoryLandingTemplate from '../../components/CategoryLandingTemplate';
import tecnalData from '../../data/tecnal';

const TECNALPage = () => {
  return <CategoryLandingTemplate data={tecnalData.tecnal} />;
};

export default TECNALPage;
